// The 8 project-mail types, shared between the workspace-wide Mail Control
// settings and each project's own Mail Settings modal. Keys match the
// columns returned by the backend (see lib/projectMailSettings.js).
export const PROJECT_MAIL_TYPES = [
  { key: 'mail_project_created',     label: 'Project Created' },
  { key: 'mail_project_updates',     label: 'Project Updates (weekly + on-demand)' },
  { key: 'mail_project_completed',   label: 'Project Completed' },
  { key: 'mail_project_expired',     label: 'Project Expired' },
  { key: 'mail_project_status',      label: 'Project Inactive / Reactivated' },
  { key: 'mail_milestone_created',   label: 'Milestone Created' },
  { key: 'mail_milestone_completed', label: 'Milestone Completed' },
  { key: 'mail_milestone_expired',   label: 'Milestone Expired' },
];

// A project's own Mail Settings modal excludes "Project Created" — that
// mail fires at the moment the project is created, before there's ever a
// chance to open this modal and turn it off, so a per-project switch for
// it would be a dead control. It's still available workspace-wide in
// Other Settings > Mail Control, and per project on the create form's
// Mail Settings section (CreateProjectModal), which uses the full list.
export const PROJECT_LEVEL_MAIL_TYPES = PROJECT_MAIL_TYPES.filter(
  (t) => t.key !== 'mail_project_created'
);
